module.exports = __webpack_public_path__ + "img/icmtrader-usdt1.43856bc3.png";